import { ReactElement } from "react";
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useTheme,
} from "@chakra-ui/react";
import { IoChevronDown, IoGlobeOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

type Props = {
  to: string;
};

export function LanguageSelector(props: Readonly<Props>): ReactElement {
  const theme = useTheme();
  const backgroundColor = theme.colors.primary["theme_lv3"];
  return (
    <Menu>
      <MenuButton
        as={Button}
        margin="10px auto"
        leftIcon={<IoGlobeOutline />}
        variant="ghost"
        borderRadius={0}
        bg="primary.bg_lv1"
        _hover={{ backgroundColor: `${backgroundColor}` }}
        _active={{ backgroundColor: `${backgroundColor}` }}
        minWidth="70px"
      >
        <Flex alignItems="center" columnGap={2}>
          <IoChevronDown />
        </Flex>
      </MenuButton>
      <MenuList minWidth="70px" borderRadius={0} backgroundColor="common.base">
        <MenuItem
          as={Link}
          to={`/ja/${props.to}`}
          color="text.subtext"
          _focus={{ backgroundColor: "primary.bg_lv1" }}
        >
          日本語
        </MenuItem>
        <MenuItem
          as={Link}
          to={`/en/${props.to}`}
          color="text.subtext"
          _focus={{ backgroundColor: "primary.bg_lv1" }}
        >
          English
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
